"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableHeaderCellClassName: function() {
        return tableHeaderCellClassName;
    },
    tableHeaderCellClassNames: function() {
        return tableHeaderCellClassNames;
    },
    useTableHeaderCellStyles_unstable: function() {
        return useTableHeaderCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableHeaderCellClassName = 'fui-TableHeaderCell';
const tableHeaderCellClassNames = {
    root: 'fui-TableHeaderCell',
    button: 'fui-TableHeaderCell__button',
    sortIcon: 'fui-TableHeaderCell__sortIcon',
    aside: 'fui-TableHeaderCell__aside'
};
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bh6795r: "fqerorx",
        Bnnss6s: "f1neuvcm",
        xawz: "fkjuxzh",
        Bf4jedk: "f10tiqix"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}",
        ".f1neuvcm{flex-shrink:1;}",
        ".fkjuxzh{flex-basis:0px;}",
        ".f10tiqix{min-width:0px;}"
    ]
});
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bhrd7zp: "figsok6",
        z8tnut: "f1nbblvp",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "f1ov4xf1",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        B3nxjsc: "fhix6mv",
        Bmvh20x: "fha7anx",
        robkg1: "f1fmzww4",
        pehzd3: [
            "fs9qmxf",
            "f187m4uq"
        ],
        B8osjzx: [
            "f187m4uq",
            "fs9qmxf"
        ],
        u7xebq: [
            "f145mzao",
            "f1uha7eq"
        ],
        Blsv9te: [
            "f1uha7eq",
            "f145mzao"
        ],
        qhf8xq: "f10pi13n"
    },
    rootInteractive: {
        Jwef8y: "f1t94bn6",
        ecr2s2: "f1wfn5kd"
    },
    resetButton: {
        B3rzk8w: "fq6nmtn",
        B7ck84d: "f1e4lqlz",
        De3pzq: "f1u2r49w",
        sj55zd: "f1ym3bx4",
        Bahqtrf: "f1mo0ibp",
        Be2twd7: "fjoy568",
        Bg96gwp: "fytdu2e",
        B68tc82: "f1mtd64y",
        Bmxbyg5: "f1y7q3j9",
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        icvyot: "f1ern45e",
        vrafjx: [
            "f1n71otn",
            "f1deefiw"
        ],
        oivjwe: "f1h8hb77",
        wvpqe5: [
            "f1deefiw",
            "f1n71otn"
        ],
        fsow6f: "fgusgyc"
    },
    button: {
        qhf8xq: "f10pi13n",
        a9b677: "fly5x3f",
        mc9l5x: "f22iagw",
        Bh6795r: "fqerorx",
        Bqenvij: "f1l02sjl",
        Bt984gj: "f122n59",
        i8kkvl: "f1ufnopg",
        Belr9w4: "f14sijuj",
        sshi5w: "f1nxs5xn",
        Bnnss6s: "f1neuvcm",
        xawz: "fkjuxzh",
        oeaueh: "f1s6fcnf"
    },
    sortable: {
        Bceei9c: "f1k6fduh"
    },
    sortIcon: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z8tnut: "fclwglc"
    },
    resizeHandle: {}
}, {
    d: [
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1nbblvp{padding-top:0px;}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1ov4xf1{padding-bottom:0px;}",
        ".fhix6mv[data-fui-focus-within]:focus-within{outline-width:2px;}",
        ".fha7anx[data-fui-focus-within]:focus-within{outline-style:solid;}",
        ".f1fmzww4[data-fui-focus-within]:focus-within{outline-color:var(--colorStrokeFocus2);}",
        ".fs9qmxf[data-fui-focus-within]:focus-within{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f187m4uq[data-fui-focus-within]:focus-within{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f145mzao[data-fui-focus-within]:focus-within{border-top-right-radius:var(--borderRadiusMedium);}",
        ".f1uha7eq[data-fui-focus-within]:focus-within{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f10pi13n{position:relative;}",
        ".fq6nmtn{resize:horizontal;}",
        ".f1e4lqlz{box-sizing:content-box;}",
        ".f1u2r49w{background-color:inherit;}",
        ".f1ym3bx4{color:inherit;}",
        ".f1mo0ibp{font-family:inherit;}",
        ".fjoy568{font-size:inherit;}",
        ".fytdu2e{line-height:normal;}",
        ".f1mtd64y{overflow-x:visible;}",
        ".f1y7q3j9{overflow-y:visible;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1qch9an{padding-bottom:0;}",
        ".f1ern45e{border-top-style:none;}",
        ".f1n71otn{border-right-style:none;}",
        ".f1deefiw{border-left-style:none;}",
        ".f1h8hb77{border-bottom-style:none;}",
        ".fgusgyc{text-align:unset;}",
        ".fly5x3f{width:100%;}",
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}",
        ".f1l02sjl{height:100%;}",
        ".f122n59{align-items:center;}",
        ".f1ufnopg{column-gap:var(--spacingHorizontalXS);}",
        ".f14sijuj{row-gap:var(--spacingHorizontalXS);}",
        ".f1nxs5xn{min-height:32px;}",
        ".f1neuvcm{flex-shrink:1;}",
        ".fkjuxzh{flex-basis:0px;}",
        ".f1s6fcnf{outline-style:none;}",
        ".f1k6fduh{cursor:pointer;}",
        ".fclwglc{padding-top:var(--spacingVerticalXXS);}"
    ],
    h: [
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}"
    ],
    a: [
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"
    ]
});
const useTableHeaderCellStyles_unstable = (state)=>{
    const styles = useStyles();
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableHeaderCellClassNames.root, styles.root, state.sortable && styles.rootInteractive, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    state.button.className = (0, _react.mergeClasses)(tableHeaderCellClassNames.button, styles.resetButton, styles.button, state.sortable && styles.sortable, state.button.className);
    if (state.sortIcon) {
        state.sortIcon.className = (0, _react.mergeClasses)(tableHeaderCellClassNames.sortIcon, styles.sortIcon, state.sortIcon.className);
    }
    if (state.aside) {
        state.aside.className = (0, _react.mergeClasses)(tableHeaderCellClassNames.aside, styles.resizeHandle, state.aside.className);
    }
    return state;
}; //# sourceMappingURL=useTableHeaderCellStyles.styles.js.map
